<template>
  <v-layout align-center justify-center v-if="progress" style="height: calc(100vh - 64px); overflow-y: scroll;">
    <v-progress-circular :size="100" :width="8" indeterminate color="blue"></v-progress-circular>
  </v-layout>
  <v-layout style="height: calc(100vh - 64px); overflow-y: scroll;" justify-center v-else>
    <!-- <v-flex xs12 sm12 md12 xl12 lg12 v-if="status_login === 'T'" class="imgBg">
      <v-layout style="margin-top: 20%;">
        <div style="color: black; margin: auto; width: 50% box-shadow: 5px 10px #888888;">
          <font size="6px">ยินดีต้อนรับสู่ ONECHAT OFFICIAL</font>
        </div>
      </v-layout>
      <v-layout row align-center justify-center style="margin-top: 25px;">
        <h4>หากคุณยังไม่มีบัญชี สร้างบัญชีได้ที่นี่</h4>
        <v-btn @click="toPage('/create_account')" class="buttoncreate"><v-icon dark style="margin-right: 0.2em; color:white;">fas fa-user-circle</v-icon>สร้างบัญชี</v-btn>
      </v-layout>
    </v-flex> -->
    <v-layout column wrap v-if="status_login === 'T'" class="imgBg">
      <div class="div-text">
        <font size="6px">ยินดีต้อนรับสู่ ONECHAT OFFICIAL</font>
        <v-layout row wrap justify-center align-center class="mt-3">
          <h3>หากคุณยังไม่มีบัญชี สร้างบัญชีได้ที่นี่</h3>
          <v-btn @click="toPage('/create_account')" class="buttoncreate"><v-icon dark style="margin-right: 0.2em; color:white;">fas fa-user-circle</v-icon>สร้างบัญชี</v-btn>
        </v-layout>
      </div>
    </v-layout>
  </v-layout>
</template>
<script>
import { Decode } from '@/services'
var _ = require('lodash')
export default {
  data () {
    return {
      tokenuser: '',
      listbot: [],
      progress: false,
      status_login: ''
    }
  },
  created () {
    // console.log(window.location.pathname)
    this.status_login = localStorage.getItem('status_login')
    this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
    this.getlistbot()
  },
  // mounted () {
  //   this.status_login = localStorage.getItem('status_login')
  //   if (this.status_login === 'T') {
  //     this.$router.push('/homepage')
  //   }
  // },
  methods: {
    toPage (data) {
      this.$router.push(data)
    },
    getlistbot () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistbot', { tokenuser: this.tokenuser }).then((response) => {
        if (response.data.message === 'success') {
          this.progress = false
          this.listbot = response.data.listbot
          if (this.listbot.length !== 0) {
            this.listbot = _.orderBy(this.listbot, ['nickname'], ['asc'])
            this.$router.push('/account/' + this.listbot[0].tokenuser)
          } else {
            this.$router.push('/homepage')
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.div-text {
  color: #252525;
  margin: auto;
  background-color: #f5f5f552;
  border-radius: 10px;
  padding: 20px;
}
.buttoncreate {
  border-radius: 50px !important;
  background-color: orange !important;
  width: 125px !important;
  box-shadow: none !important;
  color: white !important;
}
.imgBg {
  background-image: url("https://image.freepik.com/free-photo/commerce-push-ecommerce-store-cart-supermarket_1418-13.jpg");
  background-size: cover;
}
</style>
